"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subMitApply = exports.noMatchPlayer = exports.noAllotPlayer = exports.isAllotPlayer = exports.insetPlayer = exports.insertOrUpdateMatchWorks = exports.getTeacherList = exports.getPlayerStage = exports.getPlayerMatchList = exports.getPlayerListGZ = exports.getMatchWorksRule = exports.getMatchPlayerInfo = exports.getExitReasonById = exports.getApplyInfo = exports.deletePlayer = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 获取报名表退审原因
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getExitReasonById = exports.getExitReasonById = function getExitReasonById(data) {
  return _api.default.request({
    url: "/partyLog/getExitReasonById",
    method: "post",
    data: _qs.default.stringify(data)
  });
};
/**
 * 获取选手统计信息
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getMatchPlayerInfo = exports.getMatchPlayerInfo = function getMatchPlayerInfo(data) {
  return _api.default.request({
    url: "/matchWorks/getMatchPlayerInfo",
    method: "post",
    data: data
  });
};
/**
 * 获取选手统计信息
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getPlayerMatchList = exports.getPlayerMatchList = function getPlayerMatchList(data) {
  return _api.default.request({
    url: "/matchWorks/getPlayerMatchList",
    method: "post",
    data: data
  });
};
/**
 * 描述 选手阶段列表
 * @author kkdy
 * @date 2021-12-10
 * @param {any} data
 * @returns {any}
 */
var getPlayerStage = exports.getPlayerStage = function getPlayerStage(data) {
  return _api.default.request({
    url: "/matchWorks/getPlayMatchStageList",
    method: "post",
    data: data
  });
};
/**
 * 描述 获取教师列表
 * @author kkdy
 * @date 2021-12-10
 * @param {any} data
 * @returns {any}
 */
var getTeacherList = exports.getTeacherList = function getTeacherList(data) {
  return _api.default.request({
    url: "/user/teacherList",
    method: "post",
    data: data
  });
};
/**
 * 描述 获取作品设置项
 * @author whz
 * @date 2021-12-10
 * @param {any} data
 * @returns {any}
 */
var getMatchWorksRule = exports.getMatchWorksRule = function getMatchWorksRule(data) {
  return _api.default.request({
    url: "/matchScoreItemRule/getMatchWorksRule",
    method: "post",
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 提交作品
 * @author whz
 * @date 2021-12-10
 * @param {any} data
 * @returns {any}
 */
var insertOrUpdateMatchWorks = exports.insertOrUpdateMatchWorks = function insertOrUpdateMatchWorks(data) {
  return _api.default.request({
    url: "/matchWorks/insertOrUpdateMatchWorks",
    method: "post",
    data: data
  });
};
/**
 * 描述 获取学校下为参赛选手
 * @author kkdy
 * @date 2021-12-13
 * @param {any} data
 * @returns {any}
 */
var noMatchPlayer = exports.noMatchPlayer = function noMatchPlayer(data) {
  return _api.default.request({
    url: "/matchWorks/getUnPlayerList",
    method: "post",
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 获取已经分配的选手教师列表
 * @author kkdy
 * @date 2021-12-28
 * @param {any} data
 * @returns {any}
 */
var isAllotPlayer = exports.isAllotPlayer = function isAllotPlayer(data) {
  return _api.default.request({
    url: "/matchStageGroupTeacher/getAssignTeacherList",
    method: "post",
    data: data
  });
};
/**
 * 描述 插入未分配的选手教师
 * @author kkdy
 * @date 2021-12-28
 * @param {any} data
 * @returns {any}
 */
var insetPlayer = exports.insetPlayer = function insetPlayer(data) {
  return _api.default.request({
    url: "/matchStageGroupTeacher/MatchStageGroupTeacherParam",
    method: "post",
    data: data
  });
};
/**
 * 描述 获取未分配的选手教师列表
 * @author kkdy
 * @date 2021-12-28
 * @param {any} data
 * @returns {any}
 */
var noAllotPlayer = exports.noAllotPlayer = function noAllotPlayer(data) {
  return _api.default.request({
    url: "/matchStageGroupTeacher/getUnAssignTeacher",
    method: "post",
    data: data
  });
};
/**
 * 描述
 * @author kkdy
 * @date 2021-12-28
 * @param {any} data
 * @returns {any}
 */
var deletePlayer = exports.deletePlayer = function deletePlayer(data) {
  return _api.default.request({
    url: "/matchStageGroupTeacher/delete",
    method: "post",
    data: data
  });
};
/**
 * 描述
 * @author kkdy
 * @date 2021-12-28
 * @param {any} data
 * @returns {any}
 */
var getPlayerListGZ = exports.getPlayerListGZ = function getPlayerListGZ(data) {
  return _api.default.request({
    url: "/partyInfo/getMatchList",
    method: "post",
    data: data
  });
};
/**
 * 描述 提交/保存为草稿 报名表贵州
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var subMitApply = exports.subMitApply = function subMitApply(data) {
  return _api.default.request({
    url: "/partyInfo/savePartyInfo",
    method: "post",
    data: data
  });
};
/**
 * 描述 获取报名表信息
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var getApplyInfo = exports.getApplyInfo = function getApplyInfo(data) {
  return _api.default.request({
    url: "/partyInfo/getDetail",
    method: "post",
    data: _qs.default.stringify(data)
  });
};